export enum MicrositeSocialLinkPlatform {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
  X = 'X',
  TIKTOK = 'TIKTOK',
  SPOTIFY = 'SPOTIFY',
  APPLE_PODCASTS = 'APPLE_PODCASTS',
  WEBSITE = 'WEBSITE',
  EMAIL = 'EMAIL',
}
